const FEATURED_LANGUAGES = ['Thai', 'English', 'Chinese', 'Japanese', 'Korean'];

function normalize(value) {
  return value.trim().replace(/\s+/g, ' ');
}

export default function LanguageSelector({ value, onChange }) {
  const selected = value ?? [];

  function toggle(language) {
    onChange(
      selected.includes(language)
        ? selected.filter((item) => item !== language)
        : [...selected, language]
    );
  }

  function addCustom(event) {
    if (event.key !== 'Enter' && event.key !== ',') return;
    event.preventDefault();
    const language = normalize(event.currentTarget.value);
    if (!language) return;
    if (!selected.some((item) => item.toLowerCase() === language.toLowerCase())) {
      onChange([...selected, language]);
    }
    event.currentTarget.value = '';
  }

  return (
    <div>
      <div className="flex flex-wrap gap-2">
        {FEATURED_LANGUAGES.map((language) => (
          <button
            key={language}
            type="button"
            onClick={() => toggle(language)}
            className={[
              'rounded-full border px-3 py-1 text-xs font-medium transition-colors',
              selected.includes(language)
                ? 'border-brand-600 bg-brand-50 text-brand-700'
                : 'border-gray-200 bg-white text-gray-600 hover:border-gray-300',
            ].join(' ')}
          >
            {language}
          </button>
        ))}
      </div>
      <input
        className="input mt-2 text-sm"
        placeholder="Add another language, then press Enter"
        onKeyDown={addCustom}
      />
      {selected.some((language) => !FEATURED_LANGUAGES.includes(language)) && (
        <div className="mt-2 flex flex-wrap gap-2">
          {selected.filter((language) => !FEATURED_LANGUAGES.includes(language)).map((language) => (
            <button
              key={language}
              type="button"
              onClick={() => toggle(language)}
              className="rounded-full border border-brand-600 bg-brand-50 px-3 py-1 text-xs font-medium text-brand-700"
              title="Remove language"
            >
              {language} ×
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
